import { CreateEndpoint } from "../../Helpers";

const apiTransferencias = {
  namespaced: true,
  state: {
    env: "prod",
    version: "v1",
    helpers: {
      comitentes: [],
    },
    amedia: {
      login: {
        endpoint: "/login",
        method: "post",
      },
      check: {
        endpoint: "/check",
        method: "post",
      },
      logout: {
        endpoint: "/logout",
        method: "post",
      },
    },
    recursos: {
      tipoCuentas: {
        endpoint: "/recursos/tipo-cuentas-bancarias",
        method: "get",
      },
      monedas: {
        endpoint: "/recursos/monedas",
        method: "get",
      },
    },
    comitentes: {
      all: {
        endpoint: "/user/comitentes",
        method: "get",
      },
      checkOperar: {
        endpoint: "/user/comitentes/{numero}/operar",
        method: "get",
      },
    },
    external_accounts: {
      byComitente: {
        endpoint: "/gestion/{numero}/external-account",
        method: "get",
      },
      create: {
        endpoint: "/gestion/{numero}/external-account",
        method: "post",
      },
      delete: {
        endpoint: "/gestion/{numero}/external-account/{id}",
        method: "delete",
      },
      beneficiarios: {
        endpoint: "/gestion/{numero}/external-account/beneficiarios",
        method: "get",
      },
      habilitados: {
        endpoint: "/gestion/{numero}/external-account/habilitados",
        method: "get",
      },
    },
    cbu: {
      byComitente: {
        endpoint: "/gestion/{numero}/cbu",
        method: "get",
      },
      create: {
        endpoint: "/gestion/{numero}/cbu",
        method: "post",
      },
      cuitsAsociados: {
        endpoint: "/gestion/{numero}/cuits-asociados",
        method: "get",
      },
      delete: {
        endpoint: "/gestion/{numero}/cbu/{id}",
        method: "delete",
      },
      habilitados: {
        endpoint: "/gestion/{numero}/cbu/habilitados",
        method: "get",
      },
    },
    transferencias: {
      byComitente: {
        endpoint: "/gestion/{numero}/transferencias",
        method: "get",
      },
      create: {
        endpoint: "/gestion/{numero}/transferencias",
        method: "post",
      },
      checkBloqueInstructivo: {
        endpoint: "/gestion/{numero}/bloque-instructivo",
        method: "get",
      },
    },
    disponible: {
      default: {
        endpoint: "/gestion/{numero}/disponible",
        method: "get",
      },
      byFecha: {
        endpoint: "/gestion/{numero}/disponible/{fecha_desde}/{fecha_hasta}",
        method: "get",
      },
      byFechaMoneda: {
        endpoint:
          "/gestion/{numero}/disponible/{fecha_desde}/{fecha_hasta}/{moneda}",
        method: "get",
      },
    },
  },
  getters: {
    /** external acounts */
    getExternalAccountDelete: (state) => (numero, id) => {
      return CreateEndpoint(state.external_accounts.delete.endpoint, state)
        .replace(/{numero}/gi, numero)
        .replace(/{id}/gi, id);
    },
    getExternalAccountCreate: (state) => (numero) => {
      return CreateEndpoint(
        state.external_accounts.create.endpoint,
        state
      ).replace(/{numero}/gi, numero);
    },
    getExternalAccountHabilitados: (state) => (numero) => {
      return CreateEndpoint(
        state.external_accounts.habilitados.endpoint,
        state
      ).replace(/{numero}/gi, numero);
    },
    getExternalAccountBeneficiarios: (state) => (numero) => {
      return CreateEndpoint(
        state.external_accounts.beneficiarios.endpoint,
        state
      ).replace(/{numero}/gi, numero);
    },
    getExternalAccountByComitente: (state) => (numero) => {
      return CreateEndpoint(
        state.external_accounts.byComitente.endpoint,
        state
      ).replace(/{numero}/gi, numero);
    },
    /** instructivo check bloque transferencias */
    getTransferenciasCheckBloque: (state) => (numero) => {
      return CreateEndpoint(
        state.transferencias.checkBloqueInstructivo.endpoint,
        state
      ).replace(/{numero}/gi, numero);
    },
    /** transferencias */
    getTransferencias: (state) => (numero) => {
      return CreateEndpoint(
        state.transferencias.byComitente.endpoint,
        state
      ).replace(/{numero}/gi, numero);
    },
    getTransferenciasCreate: (state) => (numero) => {
      return CreateEndpoint(
        state.transferencias.create.endpoint,
        state
      ).replace(/{numero}/gi, numero);
    },
    /** cbus */
    getCbuDelete: (state) => (numero, id) => {
      return CreateEndpoint(state.cbu.delete.endpoint, state)
        .replace(/{numero}/gi, numero)
        .replace(/{id}/gi, id);
    },
    getCbuCreate: (state) => (numero) => {
      return CreateEndpoint(state.cbu.create.endpoint, state).replace(
        /{numero}/gi,
        numero
      );
    },
    getCbuHabilitados: (state) => (numero) => {
      return CreateEndpoint(state.cbu.habilitados.endpoint, state).replace(
        /{numero}/gi,
        numero
      );
    },
    getCuitsAsociados: (state) => (numero) => {
      return CreateEndpoint(state.cbu.cuitsAsociados.endpoint, state).replace(
        /{numero}/gi,
        numero
      );
    },
    getCbuByComitente: (state) => (numero) => {
      return CreateEndpoint(state.cbu.byComitente.endpoint, state).replace(
        /{numero}/gi,
        numero
      );
    },
    /** disponibles */
    getDisponibleByFechaMoneda:
      (state) => (numero, fecha_desde, fecha_hasta, moneda) => {
        return CreateEndpoint(state.disponible.byFechaMoneda.endpoint, state)
          .replace(/{numero}/gi, numero)
          .replace(/{fecha_desde}/gi, fecha_desde)
          .replace(/{fecha_hasta}/gi, fecha_hasta)
          .replace(/{moneda}/gi, moneda);
      },
    getDisponibleByFecha: (state) => (numero, fecha_desde, fecha_hasta) => {
      return CreateEndpoint(state.disponible.byFecha.endpoint, state)
        .replace(/{numero}/gi, numero)
        .replace(/{fecha_desde}/gi, fecha_desde)
        .replace(/{fecha_hasta}/gi, fecha_hasta);
    },
    getDisponible: (state) => (numero) => {
      return CreateEndpoint(state.disponible.default.endpoint, state).replace(
        /{numero}/gi,
        numero
      );
    },
    /** recursos */
    getMonedas: (state) => {
      return CreateEndpoint(state.recursos.monedas.endpoint, state);
    },
    getRecursoTipoCuentas: (state) => {
      return CreateEndpoint(state.recursos.tipoCuentas.endpoint, state);
    },
    /** user comitentes */
    getOperarComitente: (state) => (numero) => {
      return CreateEndpoint(
        state.comitentes.checkOperar.endpoint,
        state
      ).replace(/{numero}/gi, numero);
    },
    getComitentesAll: (state) => {
      return CreateEndpoint(state.comitentes.all.endpoint, state);
    },
    /** Amedia checks */
    getAmediaLogout: (state) => {
      return CreateEndpoint(state.amedia.logout.endpoint, state);
    },
    getAmediaCheck: (state) => {
      return CreateEndpoint(state.amedia.check.endpoint, state);
    },
    getAmediaLogin: (state) => {
      return CreateEndpoint(state.amedia.login.endpoint, state);
    },
  },
  actions: {},
  mutations: {},
};

export default apiTransferencias;
